import { useEffect, useState } from 'react';

export const useTransition = (time: number) => {
  const [transition, setTransition] = useState(false);

  useEffect(() => {
    const transitionTimer = setTimeout(() => setTransition(true), time);

    return () => {
      clearTimeout(transitionTimer);
    };
  }, []);

  return transition;
};
